import RequestAbstract from "../abstract";

/**
 * Telegram USER sessions (MTProto), kept connected by the tg-client pod.
 *
 * The CRUD half is the usual controller. The custom calls below are relayed by the
 * cabinet to tg-client, so a failure comes back in the cabinet envelope with the
 * Telegram error code at the front of the message — "PHONE_CODE_INVALID: ...",
 * "TG_CLIENT_UNREACHABLE: ..." — which is what the login dialog branches on.
 */
export default class PublicTgSessions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-tg-sessions";
    }

    /** Ask Telegram to send a login code to the session's phone. -> {status, codeLength, codeType} */
    async loginStart(id) {
        return await this.post(`${this.link}/${id}/login/start`, {});
    }

    /** -> {status: 'active', tgUserId, tgUsername} or {status: 'awaiting_password', hint} */
    async loginCode(id, code) {
        return await this.post(`${this.link}/${id}/login/code`, { code });
    }

    /** The account's two-step verification password. -> {status: 'active', tgUserId, tgUsername} */
    async loginPassword(id, password) {
        return await this.post(`${this.link}/${id}/login/password`, { password });
    }

    /** Ends the Telegram authorization and drops the stored session. -> {status} */
    async logout(id) {
        return await this.post(`${this.link}/${id}/logout`, {});
    }

    /**
     * Send a message through the session. `peer` is "@username" or a numeric id,
     * kept a string: Telegram ids exceed 2^53. -> {peerId, tgMessageId}
     */
    async send(id, peer, text) {
        return await this.post(`${this.link}/${id}/send`, { peer, text });
    }
}
